import type {
  GridProps} from '@chakra-ui/react'
import {
  Button,
  Divider,
  Flex,
  forwardRef,
  Grid,
  Link,
  Stack,
  Text,
} from '@chakra-ui/react'

import type { Document } from '../../data/documents'
import { DocumentIcon } from './DocumentIcon'

export interface DocumentsListProps extends GridProps {
  items?: Document[]
}

export interface DocumentsListItemProps extends GridProps, Document { }

export const DocumentsListItem = forwardRef(
  (
    {
      children,
      sx,
      name,
      lastViewed,
      documentType,
      contractDocDtype,
      url,
      ...rest
    }: DocumentsListItemProps,
    ref,
  ) => {
    return (
      <Grid
        ref={ref}
        sx={{
          gridTemplateColumns: 'auto 1fr',
          gap: 6,
          ...sx,
        }}
        {...rest}
      >
        <DocumentIcon documentType={documentType} />

        <Stack>
          <Text sx={{ fontSize: 'lg', fontWeight: 'medium' }}>{name}</Text>

          <Flex sx={{ gap: 2 }}>
            {url && <Button as={Link} href={url} target='_blank' variant="link">stáhnout</Button>}

            {lastViewed && (
              <>
                <Divider orientation="vertical" />

                <Text sx={{ fontSize: 'sm' }}>
                  Naposledy zobrazeno: {lastViewed}
                </Text>
              </>
            )}
          </Flex>
        </Stack>
      </Grid>
    )
  },
)

export const DocumentsList = forwardRef(
  ({ children, sx, items, ...rest }: DocumentsListProps, ref) => {
    return (
      <Stack
        ref={ref}
        sx={{
          gap: 8,
          ...sx,
        }}
        {...rest}
      >
        {items?.map((item, i) => {
          return <DocumentsListItem key={i} {...item} />
        })}
      </Stack>
    )
  },
)
